import { MegaphoneIcon } from "@phosphor-icons/react/dist/csr/Megaphone";
import { Button } from "@volca/ui/components/ui/button";
import { Card } from "@volca/ui/components/ui/card";
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@volca/ui/components/ui/empty";
import { ErrorState } from "@volca/ui/components/ui/error-state";
import { Spinner } from "@volca/ui/components/ui/spinner";
import { Stack } from "@volca/ui/components/ui/stack";
import { ChangelogEntryCard } from "./changelog-entry-card";
import { useChangelog } from "./query";

export const ChangelogFeed = () => {
  const query = useChangelog();
  const entries = query.data?.pages.flatMap((page) => page.items) ?? [];

  if (query.isPending) {
    return (
      <Spinner
        layout="centered"
        aria-label="Loading updates"
        className="py-12"
      />
    );
  }

  return (
    <Stack gap={6}>
      {query.isError && (
        <ErrorState
          title="Couldn’t load the product updates"
          description="Please try again."
          illustration="none"
          retrying={query.isFetching}
        >
          <Button
            variant="secondary"
            loading={query.isFetching}
            loadingLabel="Loading updates"
            onClick={() =>
              void (query.isFetchNextPageError
                ? query.fetchNextPage()
                : query.refetch())
            }
          >
            Try again
          </Button>
        </ErrorState>
      )}
      {!query.isError && entries.length === 0 && (
        <Card>
          <Empty>
            <EmptyHeader>
              <EmptyMedia variant="icon">
                <MegaphoneIcon aria-hidden />
              </EmptyMedia>
              <EmptyTitle>No updates yet</EmptyTitle>
              <EmptyDescription>
                Product updates will appear here when they’re published.
              </EmptyDescription>
            </EmptyHeader>
          </Empty>
        </Card>
      )}
      {entries.map((entry) => (
        <ChangelogEntryCard key={entry.id} entry={entry} />
      ))}
      {query.hasNextPage && (
        <Button
          variant="secondary"
          disabled={query.isFetching}
          loading={query.isFetchingNextPage}
          loadingLabel="Loading older updates"
          onClick={() => void query.fetchNextPage()}
        >
          Load older updates
        </Button>
      )}
    </Stack>
  );
};
